<template>
    <v-icon class="tile-icon-container d-flex" :class="[background, borderRadius]" :style="{padding}" :size="size + 'px'">
        
        
        <slot>
            
            <v-img :src="imageName"></v-img>

        </slot>
    
    </v-icon>
</template>



<script>

export default {
    name: "TileIcon",
    props: {
        imageName: String,
        size: {
            type: Number,
            default: 86,
        },
        padding:{
            type: String,
            default : "16px",
        },
        background:{
            type: String,
            default: "background-secondary",
        },
        borderRadius:{
            type: String,
            default: "rounded-12"
        }
    },
};

</script>



<style scoped lang="scss">

.tile-icon-container {
    border: vars.get-map-value(vars.$tile, icon, border);
}

</style>
